// Single source of truth for PFG (Warranty) state badge colors. Mirrors the
// state enum in Warranties::StateMachine. Both the show-page badge (ShowStatus)
// and the PFG table status column render from this map, so the same PFG reads
// the same color everywhere.
//
// Colors group by what the state means to the user:
//   yellow - waiting on someone (intake or a rescan from the office)
//   blue   - actively in a review queue
//   green  - approved / done
//   red    - rejected
const WARRANTY_STATE_COLORS = {
  pending: 'yellow',
  pending_rescan_requested: 'yellow',
  lab_review: 'blue',
  customer_service_review: 'blue',
  orthodontic_office_review: 'blue',
  partner_success_review: 'blue',
  review_for_production: 'blue',
  approved: 'green',
  rejected: 'red',
};

// Accepts either the raw enum value ("lab_review") or the humanized form the
// AG Grid value getters produce ("lab review"). Returns null for anything that
// is not a warranty state so callers can fall back to their own default.
function warrantyStateColor(state) {
  if (!state) {
    return null;
  }

  const key = String(state).toLowerCase().replace(/\s+/g, '_');

  return WARRANTY_STATE_COLORS[key] || null;
}

export default warrantyStateColor;
